{
    "second": "s",
    "hertz": "Hz",
    "decibel": "dB",
    "semitone": "st"
}